// tslint:disable
export enum CaseCaseFollowUpSyncAction {
    /**
     * @description Sync from Case Entities from Account Entities
     */
    SyncFromAccount = 0,
    /**
     * @description Complete
     */
    SyncFromCase = 1,
    /**
     * @description Manually sync using case relationships in the CaseFollowUpResultModel
     */
    Manual = 2,
}
(CaseCaseFollowUpSyncAction as any)['SYNCFROMACCOUNT'] = 0;
(CaseCaseFollowUpSyncAction as any)['SYNCFROMCASE'] = 1;
(CaseCaseFollowUpSyncAction as any)['MANUAL'] = 2;
